import { render, staticRenderFns } from "./SocialScheduleCalendar.vue?vue&type=template&id=1a2b05a2&"
import script from "./SocialScheduleCalendar.vue?vue&type=script&lang=js&"
export * from "./SocialScheduleCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2b05a2')) {
      api.createRecord('1a2b05a2', component.options)
    } else {
      api.reload('1a2b05a2', component.options)
    }
    module.hot.accept("./SocialScheduleCalendar.vue?vue&type=template&id=1a2b05a2&", function () {
      api.rerender('1a2b05a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialScheduleCalendar.vue"
export default component.exports